// https://codepen.io/kriz/pen/jdxYXY
export default class CanaryIslandsControl {
  constructor({ main, opts }) {
    this._ = main;
    this._className = opts.className;
    this._title = opts.title;
    this.displayCanary = true;
    this.setOptions(opts);
    this.zoom = opts.zoom;
    this.center = opts.center;
  }

  setOptions(opts) {
    Object.keys(opts).forEach((opt) => {
      this[opt] = opts[opt];
    }, this);
  }

  onAdd(map) {
    this._btn = document.createElement("button");
    this._el = document.createElement("span");
    this._el.className = "mapboxgl-ctrl-icon" + " " + this._className;
    this._btn.type = "button";
    this._btn.title = this._title;
    this._btn.onclick = this.flyTo.bind(this, map);
    this._btn.appendChild(this._el);

    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
    this._container.appendChild(this._btn);
    return this._container;
  }

  flyTo(map) {
    this.checkIfMapsIsOverCanaryIslands(map);
    this._.map.events.mouseleave();

    if (this.displayCanary) {
      this.displayCanary = false;
      map.fitBounds(this.getCanaryBounds());
    } else {
      this.displayCanary = true;
      map.flyTo({
        center: this.center,
        zoom: this.zoom,
      });
    }
  }

  checkIfMapsIsOverCanaryIslands(map) {
    if (map.getCenter().lng < -11) {
      this._el.classList.remove("mapbox-gl-canary-islands");
      this._el.classList.add("mapbox-gl-peninbal");
    } else {
      this._el.classList.add("mapbox-gl-canary-islands");
      this._el.classList.remove("mapbox-gl-peninbal");
    }
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }

  getCanaryBounds() {
    return [
      [-13.33, 29.41],
      [-18.16, 27.63],
    ];
  }
  getPeninbalBounds() {
    return [
      [-9.29, 36.01],
      [4.3, 43.77],
    ];
  }
}
